import * as yup from 'yup';
import { SlideoutMenuLink } from '../../components';
import { schema as sectionSchema } from './slideout_menu_section';

export const component = SlideoutMenuLink;

export const schema = yup
  .object({
    link_text: yup.string(),
    menu_header: yup.string(),
    sections: yup.array(sectionSchema),
  })
  .transform(value => ({
    linkText: value.link_text,
    menuHeader: value.menu_header,
    sections: value.sections,
    component: 'slideout_menu_link',
  }));
